import { el, clear } from './core/dom.js';
import { api } from './core/api.js';
import { initTheme, toggleTheme } from './core/theme.js';
import { legacyHashAppUrl } from './core/route-map.js';
import { startRouter, navigate } from './core/router.js';
import { skeleton } from './components/skeleton.js';
import { toast } from './components/toast.js';
import { mountShell } from './shell.js';
import { isAuthPath } from './screens/auth/model.js';

function rememberUser(me) {
  try {
    localStorage.setItem('user', JSON.stringify({
      id: me.id,
      email: me.email,
      name: me.name,
      role: me.role,
      tenant_name: me.tenant_name,
      tenant_slug: me.tenant_slug,
      tenant_plan: me.tenant_plan,
    }));
  } catch {
    /* ignore */
  }
}

function logout() {
  try {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('user');
    localStorage.removeItem('selectedProductId');
  } catch {
    /* ignore */
  }
  window.location.href = '/app/login';
}

function showBoot() {
  const root = document.getElementById('app');
  clear(root);
  root.append(el('div', { class: 'boot' }, skeleton(4)));
}

function bindKeys(shell) {
  window.addEventListener('keydown', (event) => {
    const key = event.key.toLowerCase();
    if (!(event.metaKey || event.ctrlKey)) return;
    if (key === 'k') {
      event.preventDefault();
      shell.openSearch();
      return;
    }
    const typing = event.target instanceof Element && event.target.closest('input, textarea');
    if (key === 'n' && !typing) {
      event.preventDefault();
      navigate(shell.productPath('/app/chat/new'));
    }
  });
}

async function boot() {
  const legacy = legacyHashAppUrl(window.location);
  if (legacy) {
    window.location.replace(legacy);
    return;
  }
  initTheme();

  const path = String(window.location.pathname || '').split('?')[0].replace(/\/+$/, '') || '/';
  if (isAuthPath(path)) {
    const { mountAuth } = await import('./screens/auth/index.js');
    mountAuth();
    return;
  }

  let token = '';
  try { token = localStorage.getItem('accessToken') || ''; } catch { /* ignore */ }
  if (!token) {
    window.location.replace('/app/login');
    return;
  }
  showBoot();
  const me = await api('/auth/me');
  if (!me || me.error) {
    window.location.replace('/app/login');
    return;
  }
  rememberUser(me);
  const shell = mountShell({
    me,
    onTheme() {
      const next = toggleTheme();
      toast(next === 'dark' ? 'Dark mode' : 'Light mode');
    },
    onLogout() { logout(); },
  });
  startRouter({
    context() {
      return {
        token: localStorage.getItem('accessToken'),
        role: me.role,
        tenantSlug: me.tenant_slug,
      };
    },
    onRoute(view) { shell.show(view); },
  });
  bindKeys(shell);
}

boot();
